<template>
  <div class="document-type">
    <ul class="document-tabs">
      <li
        class="document-tab__item"
        v-for="(tab, index) in filteredTabs"
        :key="index"
        :label="tab.label"
        :name="tab.name"
        :class="{ is_active: activeButton === tab.name }"
      >
        <button
          class="document-tab-button"
          @click="[filterDocumentByType(tab), (activeButton = tab.name)]"
        >
          {{ tab.label }}
        </button>
      </li>
    </ul>
    <!-- Mensaje adicional solo si no es branded -->
    <div class="warning-box">
      <div class="warning-header">
        <span class="warning-icon">
          <img
            src="@/assets/scss/icons/triangle-exclamation-solid-full.svg"
            class="show-load-icon"
            alt="warning-icon"
          />
        </span>
        <strong>Important review</strong>
      </div>

      <p class="warning-text">
        Please make sure the <strong>Bill of Lading is provided to your shipper</strong>
        to avoid any potential delays and/or extra charges.
        <strong v-if="!tokenInfo.is_branded">
          If you need to submit additional documents for this load, please send them to {{ email }}.
        </strong>
      </p>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len */
export default {
  name: "DocumentTypeToolbar",
  props: {
    role: String,
    chosenLoad: Object,
    documents: {
      type: Array,
      default: () => [],
    },
    invoiceDocument: {
      type: Array,
      default: () => [],
    },
    tokenInfo: Object,
  },
  data() {
    return {
      activeButton: "allDocs",
      keyTabs: 0,
      parcelModeId: "a0k1I00000B6pAYQAZ",
      ltlModeId: "a0k1I0000005NnyQAE",
      ltlCanadaModeId: "a0k3s00000aZwb3AAC",
      tabs: [
        {
          label: "ALL DOCS",
          name: "allDocs",
          condition: () => true,
        },
        {
          label: "MY DOCS",
          name: "/portal-tender-documents/",
          condition: () => true,
        },
        {
          label: this.$t("myLoads.myLoadsDetail.bol"),
          name: "/bol/",
          condition: () => this.chosenLoad.mode_id !== this.parcelModeId && this.verifyDocumentExistence("bol"),
        },
        {
          label: this.$t("myLoads.myLoadsDetail.labels"),
          name: "labels",
          condition: () => this.verifyDocumentExistence("shipping_labels") || this.verifyDocumentExistence("shiping-labels"),
        },
        {
          label: "SIGNED BOL",
          name: "BILL_OF_LADING",
          condition: () => this.verifyDocumentExistence("BILL_OF_LADING"),
        },
        {
          label: "POD",
          name: "DELIVERY_RECEIPT",
          condition: () => {
            this.verifyDocumentExistence("DELIVERY_RECEIPT");
            return this.enablePodDocument;
          },
        },
        {
          label: "WEIGHT CERTIFICATE",
          name: "WEIGHT_CERTIFICATE",
          condition: () => this.verifyDocumentExistence("WEIGHT_CERTIFICATE"),
        },
        {
          label: "INVOICE",
          name: "invoice",
          condition: () => this.invoiceDocument[0] && !this.tokenInfo.is_branded,
        },
      ],
    };
  },
  created() {
    const tab = {
      name: "allDocs",
    };
    this.filterDocumentByType(tab, false);
  },
  computed: {
    enablePodDocument() {
      return (
        (this.chosenLoad.mode_id === this.ltlModeId ||
          this.chosenLoad.mode_id === this.ltlCanadaModeId) &&
        (this.chosenLoad.load_status === "Completed" || this.chosenLoad.load_status === "Delivered")
      );
    },
    filteredTabs() {
      return this.tabs.filter((tab) => tab.condition());
    },
    email() {
      switch (this.chosenLoad.mode_name.toLowerCase()) {
        case "ltl":
          return "ltl@goglt.com";
        case "parcel":
          return "ltl@goglt.com";
        case "expedited":
          return "otr@goglt.com";
        case "flatbed":
          return "otr@goglt.com";
        case "reefer":
          return "otr@goglt.com";
        case "drayage":
          return "drayage@goglt.com";
        default:
        case "ftl":
          return "otr@goglt.com";
      }
    },
  },
  methods: {
    filterDocumentByType(tab) {
      const type = tab.name;
      this.activeButton = type;
      const payload = {
        type,
      };
      payload.executedGenerateDocument = true;
      if (type === "allDocs" || type === "/portal-tender-documents/") {
        payload.previewMode = true;
        payload.executedGenerateDocument = false;
      } else {
        payload.previewMode = true;
      }
      this.$emit("buttonClicked", payload);
    },
    verifyDocumentExistence(type) {
      return this.documents.some((document) => document.url.includes(type));
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/buttons/_buttons' as *;
.document-type {
  width: 100%;
  margin-bottom: 10px;
  .additional-documents-message {
    margin: 10px 0;
    p {
      font-style: italic;
    font-family: "Montserrat";
    text-align: left;
      font-size: 12px;
      color: $color-primary-company;
    }
  }
  &__button {
    border: 1px solid $color-border-container;
    background-color: $color-white;
    color: $color-primary-company;
    font-size: 10px;
    border-radius: 6px;
    padding: 2px 6px;
    margin-right: 5px;
    width: 20%;
    height: 30px;
  }
}
.document-tabs {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  gap: 5px;
  margin: 0;
  padding: 0;
}
.document-tab-button {
  @include button-tag();
}
.is_active .document-tab-button {
  background-color: $color-border-container;
  color: $color-white;
}
.warning-box {
  background-color: #fbe6c2;        /* Fondo amarillo suave */
  padding: 10px;
  border-radius: 10px;
  color: #0a3a52;                   /* Azul oscuro del texto */
  max-width: 100%;
  margin-top: 15px;

  text-align: start;
  font-style: italic;
  font-family: "Montserrat";
  text-align: left;
  font-size: 12px;
}

.warning-header {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-bottom: 6px;
  color: $color-primary-company;
}

.warning-icon {
  font-size: 12px;
}

.warning-text {
  margin: 0;
  font-size: 12px;
  color: $color-primary-company;
}

.warning-text strong {
  font-weight: 700;
}

.show-load-icon{
  width: 15px;
}
</style>
